import React from "react";
import "./TagCloud.css";



const TagCloud = () => {
  return (
    <div className="whatsNew container--full">
      {/* <h3>Tag cloud</h3> */}
      <div className='container'>
        <div className="whatsNew-cloud">
          <p className="item-1">Reinforcement Learning</p>
          <p className="item-2">Neural Networks</p>
          <p className="item-3">Explainability</p>
          <p className="item-4">AI</p>
          <p className="item-5">Data</p>
          <p className="item-6">Pandas</p>
          <p className="item-7">Deployment</p>
          <p className="item-8">Neural Networks</p>
          <p className="item-9">ML Models</p>
          <p className="item-10">Sensor Data</p>
          <p className="item-11">Decision Science</p>
          <p className="item-12">Prediction</p>
          <p className="item-13">Deployment</p>
          <p className="item-14">MLOps</p>
          <p className="item-15">Hyperopt</p>
          <p className="item-16">Explainability</p>
        </div>
      </div>
    </div>
  );
};
export default TagCloud;

